import React from "react";
import { MainContainer, TitleContainer } from "./styles";
import { SectionItemProps } from "./types";
import Typography from "../Typography";
import { Column } from "../../themes/globalStyle";

const SectionItem: React.FC<SectionItemProps> = ({
  description,
  icon,
  title,
  isTitle,
  isList,
}): JSX.Element => {
  return (
    <MainContainer>
      <TitleContainer>
        {!isTitle && icon}
        <Typography
          text={title}
          size={isTitle ? "large" : "medium"}
          color="Black500"
          weight={isTitle ? 700 : 600}
        />
      </TitleContainer>
      {!isList && typeof description === "string" ? (
        <Typography
          text={description}
          size={isTitle ? "small" : "medium"}
          color={isTitle ? "Black300" : "Black500"}
          weight={400}
        />
      ) : (
        <Column>
          {typeof description !== "string" &&
            description.length > 0 ?
            description.map((desc) => (
              <Typography
                text={`● ${desc}`}
                size={isTitle ? "small" : "medium"}
                color={isTitle ? "Black300" : "Black500"}
                weight={400}
              />
            )) : <></>}
        </Column>
      )}
    </MainContainer>
  );
};

export default SectionItem;
